import { useSelector } from "react-redux";

import { RootStateInterface } from "reducer";
import { IModalState } from "scenes/Modal/ducks";

import ClassificationPointModal from "./ClassificationPointModal/ClassificationPointModal";
import DeleteModal from "./DeleteModal/DeleteModal";
import EditPolygonModal from "./EditPolygonModal/EditPolygonModal";
import FormModal from "./FormModal/FormModal";
import PreloaderModal from "./PreloaderModal/PreloaderModal";
import ProgressModal from "./ProgressModal/ProgressModal";
import ProviderFileManagerModal from "./ProviderFilesManagerModal/ProviderFilesManagerModal";
import ProviderFoldersFilesManagerModal from "./ProviderFoldersFilesManagerModal/ProviderFoldersFilesManagerModal";
import ProviderManagerModal from "./ProviderManagerModal/ProviderManagerModal";
import ShareProjectModal from "./ShareProjectModal/ShareProjectModal";
import SuccessModal from "./SuccessModal/SuccessModal";

const MODAL_COMPONENTS = {
  PRELOADER: PreloaderModal,
  PROGRESS: ProgressModal,
  DELETE: DeleteModal,
  FORM: FormModal,
  SHARE_PROJECT: ShareProjectModal,
  EDIT_POLYGON: EditPolygonModal,
  SUCCESS: SuccessModal,
  PROVIDER_MANAGER_MODAL: ProviderManagerModal,
  PROVIDER_FILE_MANAGER_MODAL: ProviderFileManagerModal,
  PROVIDER_FOLDERS_FILES_MANAGER_MODAL: ProviderFoldersFilesManagerModal,
  CLASSIFICATION_POINT_MODAL: ClassificationPointModal
};

const ModalRoot = () => {
  const { modalType, modalProps } = useSelector<
    RootStateInterface,
    IModalState
  >((state) => state.modal);

  if (!modalType) {
    return <></>;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];

  return <SpecificModal {...modalProps} />;
};

export default ModalRoot;
